import React from 'react';
import { useTheme } from './theme-provider';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Tooltip from '@mui/material/Tooltip';

const ThemeToggle = () => {
  const { themeMode, toggleTheme } = useTheme();
  
  return (
    <Tooltip title={themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton 
        onClick={toggleTheme} 
        color="inherit"
        aria-label={themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        sx={{ 
          ml: 1,
          color: themeMode === 'dark' ? '#e0e0e0' : 'rgba(0,0,0,0.65)',
          '&:hover': {
            backgroundColor: themeMode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)'
          }
        }}
      >
        {themeMode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;